"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _base = _interopRequireDefault(require("../../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledWeekday = _styledComponents.default.div`
  &,
  &.DayPicker-Weekday {
    border: none;
    min-width: 40px;
    font-weight: 800;
    color: ${({
  theme
}) => theme.colors.border};
    text-transform: uppercase;
    font-size: 12px;
    text-align: center;
    padding: 20px 0 5px;
  }
`;
StyledWeekday.defaultProps = {
  theme: _base.default
};
var _default = StyledWeekday;
exports.default = _default;